interface WindowWithWebKit extends globalThis.Window {
  webkit?: { messageHandlers?: unknown };
}

export function getIsInApp(): boolean {
  if (typeof window === 'undefined') return false;
  const w = window as WindowWithWebKit;
  const hasIOSBridge = w.webkit != null && 'messageHandlers' in w.webkit;
  const hasAndroidBridge = 'AndroidBridge' in window;
  return hasIOSBridge || hasAndroidBridge;
}

export function getIsAndroid(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent);
}

export function getIsAndroidInAppWebView(): boolean {
  if (typeof window === 'undefined') return false;
  const hasFlutterBridge =
    typeof window.FlutterWebViewBridge?.postMessage === 'function';
  return getIsAndroid() && (hasFlutterBridge || 'AndroidBridge' in window);
}

export function getInAppDeeplink(): string | undefined {
  return import.meta.env.VITE_INAPP_DEEPLINK || undefined;
}
